const FloatingBackground = () => {
  return (
    <div className="floating-bg" />
  )
}

export default FloatingBackground